import React from 'react';
import { isNum, clamp } from './chartUtils';
import './charts.css';

/** Radar over axes [{key,label,value}] (3+ axes with numeric values). Values are 0..max. */
const Radar = ({ axes, max = 100, label, size = 320, valueSuffix = '%', testId }) => {
  const list = (axes || []).filter((a) => a && isNum(a.value));
  if (list.length < 3) return null;
  const cx = size / 2;
  const R = size / 2 - 64;
  const n = list.length;
  const pt = (i, f) => {
    const a = -Math.PI / 2 + (2 * Math.PI * i) / n;
    return [cx + Math.cos(a) * R * f, cx + Math.sin(a) * R * f];
  };
  const poly = (f) => list.map((_, i) => pt(i, f).join(',')).join(' ');
  const data = list.map((a, i) => pt(i, clamp(a.value / max, 0, 1)).join(',')).join(' ');
  const aria = `${label || 'Radar'}: ${list.map((a) => `${a.label} ${a.value}${valueSuffix}`).join(', ')}`;
  return (
    <svg className="pl-chart" role="img" aria-label={aria} viewBox={`0 0 ${size} ${size}`} width="100%" style={{ maxWidth: size }} data-testid={testId}>
      <title>{aria}</title>
      <desc>Radar chart; one axis per item.</desc>
      {[0.25, 0.5, 0.75, 1].map((f) => <polygon key={f} points={poly(f)} fill="none" stroke="var(--chart-grid)" strokeWidth="1" />)}
      {list.map((a, i) => { const [x, y] = pt(i, 1); return <line key={a.key} x1={cx} y1={cx} x2={x} y2={y} stroke="var(--chart-grid)" strokeWidth="1" />; })}
      <polygon points={data} fill="var(--chart-1)" fillOpacity="0.2" stroke="var(--chart-1)" strokeWidth="2" strokeLinejoin="round" />
      {list.map((a, i) => {
        const [x, y] = pt(i, clamp(a.value / max, 0, 1));
        const [lx, ly] = pt(i, 1.2);
        const anchor = lx < cx - 4 ? 'end' : lx > cx + 4 ? 'start' : 'middle';
        return (
          <g key={a.key}>
            <circle cx={x} cy={y} r="4" fill="var(--chart-1)" stroke="var(--color-bg-white)" strokeWidth="2" />
            <text x={lx} y={ly} textAnchor={anchor} fontSize="11">{a.label}</text>
            <text x={lx} y={ly + 12} textAnchor={anchor} fontSize="11" className="pl-chart__muted">{`${a.value}${valueSuffix}`}</text>
          </g>
        );
      })}
    </svg>
  );
};

export default Radar;
